<div id="home" class="home bg-light pb-5">
    <!-- ======================================= -->
    <div class="modal fade research-modal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title align-bottom" id="exampleModalLabel">
                        {{currentResearch.title}}
                        <i class="fs-6 bi bi-card-image ms-2 text-info" *ngIf="currentResearch.type=='img'"></i>
                        <i class="fs-6 bi bi-film ms-2 text-primary" *ngIf="currentResearch.type=='video'"></i>
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <video id="research-video" *ngIf="currentResearch.type=='video'" class="rounded w-100"
                        [src]="currentResearch.url" controls type="video/mp4">
                    </video>
                    <img id="research-img" class="rounded w-100" *ngIf="currentResearch.type=='img'"
                        [src]="currentResearch.url">
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="modal"
                        (click)="closeResearchModal()">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!-- ======================================= -->
    <div class="container">
        <div class="row justify-content-around">
            <div class="col-12 col-sm-5 col-lg-3">
                <img src="../../assets/img/shangpeng_sun.jpg"
                    class="img-fluid rounded img-thumbnail shadow-sm shangpeng-img">
                <table class="table table-sm mt-3 mb-1 info-table">
                    <tbody>
                        <tr>
                            <td class="px-0 icon-box">
                                <img src="../../assets/img/google-logo.png" style="height: 1.2rem;">
                            </td>
                            <td class="px-0">
                                <a href="https://scholar.google.com/citations?user=HzOdf-IAAAAJ&hl=en" target="_blank">
                                    Google Scholar
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td class="px-0 icon-box">
                                <i class="bi bi-envelope-fill"></i>
                            </td>
                            <td class="px-0">
                                <a href="mailto:shangpeng.sun@mcgill.ca">
                                    shangpeng.sun@mcgill.ca
                                </a>
                                <i class="bi bi-files copy-email-icon" (click)="copyEmail('shangpeng.sun@mcgill.ca')"
                                    data-bs-toggle="tooltip" data-bs-placement="top" title="Click to copy"
                                    *ngIf="isCopyEmail==false"></i>
                                <i class="bi bi-check2-square" *ngIf="isCopyEmail==true"></i>
                            </td>
                        </tr>
                        <tr>
                            <td class="icon-box px-0">
                                <i class="bi bi-geo-alt-fill me-3"></i>
                            </td>
                            <td class="px-0 text-secondary">
                                <p class="mb-2">MS1-100, Macdonald-Stewart Building, Macdonald
                                    Campus</p>
                                <p>21,111 Lakeshore Road Ste-Anne-de-Bellevue QC, H9X 3V9, Canada
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12 col-sm col-lg-8 text-secondary self-introduction">
                <p class="fs-4 fw-bold text-dark">Shangpeng Sun, Ph.D.</p>
                <p class="">Assistant Professor</p>
                <p class="">Department of Bioresource Engineering, McGill University</p>
                <p>
                    I am an Assistant Professor in the Department of Bioresource Engineering at <a
                        href="https://www.mcgill.ca/" target="_blank">McGill
                        University</a>. I
                    received my PhD degree from College of Engineering at the <a href="https://www.uga.edu/"
                        target="_blank">University of Georgia</a>,
                    Athens, USA. My
                    main research interests are to develop and adopt innovative sensing technologies
                    and
                    AI-driven
                    computational methodology for solving challenges in next-generation smart
                    agriculture,
                    improving the
                    production of high-quality food in the face of the rapidly growing human
                    population and
                    global
                    environmental change.
                </p>
                <p class="px-0 fw-semibold mt-4 text-dark">Specifically, my research interests
                    include</p>
                <table class="table p-0">
                    <tbody>
                        <tr *ngFor="let item of researchInterests">
                            <td class="px-0 border-0">
                                <i class="bi bi-caret-right-fill text-secondary me-1"></i>
                            </td>
                            <td class="px-0 border-0">{{item}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-secondary">
                <!-- ------------ -->
                <div class="container">
                    <div class="row px-0 mt-4 justify-content-center">
                        <div class="col-12 rounded research-box px-0 pb-2">
                            <div class="item" *ngFor="let item of researchs; let i=index"
                                [ngClass]="{'me-2': i!=(researchs.length-1)}">
                                <video *ngIf="item.type=='video'" class="rounded" [ngClass]="'item-'+i"
                                    data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="zoomIn(item)"
                                    autoplay loop muted>
                                    <source type="video/mp4" [src]="item.url">
                                </video>
                                <img class="rounded" [ngClass]="'item-'+i" *ngIf="item.type=='img'" [src]="item.url"
                                    (click)="zoomIn(item)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            </div>
                        </div>
                        <p class="text-center mt-3">
                            <span class="">
                                <i class="bi bi-arrow-bar-left"></i>
                                <i class="bi bi-mouse2-fill mx-1"></i>
                                <i class="bi bi-arrow-bar-right"></i>
                                <span class="ms-3">Scroll horizontally to see more</span>
                            </span>
                        </p>
                    </div>
                </div>
                <!-- ----------- -->
                <p class="mt-4 mb-0 text-dark fs-4 fw-semibold sub-title">Recruiting</p>
                <div class="mt-4 mb-3 text-dark fw-bold">For Prospective Students / Postdocs</div>
                <div class="mt-1">
                    <!-- ---------- -->
                    I am actively looking for strong and motivated students in the areas of deep
                    learning, computer
                    vision, 3D modeling, ag-robots, and digital agriculture. Also, we welcome <a
                        href="https://www.mcgill.ca/gps/funding/international-student-postdoctoral-funding-opportunities/international/csc-chinese-students"
                        target="_blank">CSC</a> supported visiting
                    students and professors. If you are interested in my research, please send me an
                    <a href="mailto:shangpeng.sun@mcgill.ca">email</a> with the
                    subject of “Prospective PhD/Master student [Your name]”, or apply through the <a
                        href="https://future.mcgill.ca/manage/" target="_blank">McGill
                        Slate</a> system
                    and mention me in your application. Due to the large volume of emails, I
                    apologize for not replying
                    to individual inquiries I have received. Please visit <a
                        href="https://www.mcgill.ca/gradapplicants/programs/bioresource-engineering"
                        target="_blank">here</a> for detailed information for your
                    applications.
                    <!-- --------- -->
                    <p class="my-3">Scholarship opportunities :</p>
                    <div class="container mb-4">
                        <div class="row">
                            <div class="col px-0">
                                <div class="opportunities mb-4" *ngFor="let item of scholarships; let i=index">
                                    <div class="level text-secondary me-4">
                                        for
                                        <span class="text-dark fw-bold">{{item.level}}</span>
                                        :
                                    </div>
                                    <div class="opporunity-box">
                                        <div class="opporunity"
                                            *ngFor="let opportunity of item.opportunities; let i=index">
                                            <a class="opporunity" [href]="opportunity.url"
                                                target="_blank">{{opportunity.title}}</a>
                                            <span *ngIf="i!=item.opportunities.length-1"
                                                class="mx-2 text-secondary">/</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>